<template>
  <Header />
  <component :is="componentId">
    <router-view />
  </component>
  <Footer />
</template>

<script>
import Header from "@/components/layouts/Header.vue";
import Footer from "./components/layouts/Footer.vue";
import PersonalLayout from "./layout/PersonalLayout.vue";
export default {
  name: "App",
  components: {
    Header,
    Footer,
    PersonalLayout,
  },
  data: () => ({}),
  computed: {
    componentId() {
      return (this.$route.meta.layout || "base") + "-layout";
    },
  },
};
</script>
<style lang="scss"></style>
